<script>
import forEach from "lodash/forEach";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
export default {
  props: {
    items: Array,
  },
  components: {
    MaskedInput,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100],
      filter: "",
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
      }),
      selectAll: false,
    };
  },
  methods: {
    formatDate(data) {
      return new Date(data).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
      });
    },
    deleteRow(row) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("deleteOB", row.id);
        }
      });
    },
    deleteAll() {
      this.$swal({
        title: "Are you sure?",
        text: "Are you sure you want to remove all the items listed below?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        confirmButtonText: "Yes, remove them!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit("removeAll");
        }
      });
    },
    toggleSelect() {
      if (this.selectAll) {
        forEach(this.items, (item) => {
          item.isChecked = true;
        });
      } else {
        forEach(this.items, (item) => {
          item.isChecked = false;
        });
      }
    },
    filterItems(items) {
      if (this.filter.trim() != "" && this.filter) {
        return items.filter((item) => {
          return item.filterKey
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      return items;
    },
    allowAddOrTransfer(x, y) {
      if (this.getExactAmt(x.amount) > 0) {
        y.showAdd = true;
      } else {
        y.showAdd = false;
        y.allowAdd = false;
        y.allowedToExceed = false;
        x.allowTransfer = false;
      }
    }
  },
  computed: {
    filtered() {
      let data = this.items;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.filterKey
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    rows() {
      let data = this.items;
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.filterKey
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      return data.length;
    },
  },
};
</script>

<template>
  <div>
    <div id="datatable_wrapper" class="dataTables_wrapper dt-bootstrap4 no-footer">
      <div class="row mb-2">
        <div class="col-sm-12 col-md-12">
          <div id="tickets-table_length" class="dataTables_length">
            <label class="d-inline-flex align-items-center">
              <b-form-input v-model="filter" type="search" placeholder="Search..."
                class="form-control form-control-sm"></b-form-input>
              <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="pageOptions"
                style="width: 75px;"></b-form-select>
            </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Account</th>
                <th>Amount</th>
              </tr>
            </thead>
            <tbody>
              <template v-if="$store.state.financeTemplate.isAvailableOEisLoading">
                <tr>
                  <td colspan="100%">
                    <div class="d-flex justify-content-center align-items-center">
                      <div class="preloader-component me-2">
                        <div class="status">
                          <div class="spinner-chase w-20px h-20px">
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                            <div class="chase-dot"></div>
                          </div>
                        </div>
                      </div>
                      <strong>Loading...</strong>
                    </div>
                  </td>
                </tr>
              </template>
              <template v-if="!$store.state.financeTemplate.isAvailableOEisLoading && items.length == 0">
                <tr>
                  <td colspan="100%" class="text-center">
                    <h5 class="text-secondary mb-0">No data available.</h5>
                  </td>
                </tr>
              </template>
              <template v-else>
                <template v-for="y in filtered">
                  <tr :key="y.id">
                    <td colspan="100%" class="py-1 align-middle">
                      <div class="d-flex flex-column my-2">
                        <h5 class="text-primary font-size-15 mb-0">{{ y.fundClassName }}</h5>
                        <div class="d-flex gap-2">
                          <div class="
                            form-check
                            form-checkbox-outline
                            form-check-success
                            mb-0
                            " v-if="y.showAdd">
                            <input type="checkbox" :id="`allowAdd-${y.id}`" checked="checked" class="form-check-input"
                              v-model="y.allowAdd" /><label :for="`allowAdd-${y.id}`" class="form-check-label">
                              Allow DU to add Account
                            </label>
                          </div>
                          <!-- <div class="
                            form-check
                            form-checkbox-outline
                            form-check-success
                            mb-0
                            " v-if="y.showAdd">
                            <input type="checkbox" :id="`allowedToExceed-${y.id}`" checked="checked"
                              class="form-check-input" v-model="y.allowedToExceed" /><label
                              :for="`allowedToExceed-${y.id}`" class="form-check-label">
                              Allow to Exceed Amount
                            </label>
                          </div> -->
                        </div>
                      </div>
                    </td>
                  </tr>
                  <template v-for="x in filterItems(y.items)">
                    <tr :key="`first-${y.id}-${x.id}`">
                      <td class="py-1 align-middle">
                        <div class="ms-4">
                          <h5 class="mb-0 text-warning font-size-15">{{ x.accountGroup.groupName }}</h5>
                          <div class="
                              form-check
                              form-checkbox-outline
                              form-check-success
                              mb-0
                              ">
                            <input type="checkbox" :id="`allowTransfer-${x.id}`" checked="checked"
                              class="form-check-input" v-model="x.allowTransfer" /><label :for="`allowTransfer-${x.id}`"
                              class="form-check-label">
                              Allow DU to transfer Amount
                            </label>
                          </div>
                        </div>
                      </td>
                      <td>
                        <masked-input autocomplete="off" type="text" v-model="x.amount" placeholder="Enter Amount..."
                          class="form-control text-right" :mask="currencyMask"
                          @input="allowAddOrTransfer(x, y)"></masked-input>
                      </td>
                    </tr>
                  </template>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <!-- <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end">
            <ul class="pagination pagination-rounded mb-0">
              <b-pagination
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
              ></b-pagination>
            </ul>
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>
